import type { FC } from 'react';
import React, { useCallback } from 'react';
import { Input } from 'antd';
import type { EndNodeType } from './types';
import type { NodePanelProps } from '../../types';
import Field from '../_base/components/field';
import InputVarTypeIcon from '../_base/components/input-var-type-icon';
import { InputVarType } from '../../types';
import {
  WorkflowHistoryEvent,
  useNodeDataUpdate,
  useWorkflowHistory,
} from '../../hooks';

const Panel: FC<NodePanelProps<EndNodeType>> = ({id, data}) => {
    const { saveStateToHistory } = useWorkflowHistory();
    const { handleNodeDataUpdate, handleNodeDataUpdateWithSyncDraft } =
      useNodeDataUpdate();

  const handleDescriptionChange = useCallback(
      (desc: string) => {
        handleNodeDataUpdateWithSyncDraft({ id, data: { desc } });
        saveStateToHistory(WorkflowHistoryEvent.NodeDescriptionChange);
      },
      [handleNodeDataUpdateWithSyncDraft, id, saveStateToHistory],
    );
  
  return (
    <div className="mt-2">
      <div className="space-y-4 px-4 pb-2">
       <Field title="描述">
          <div
            className="flex min-h-8 cursor-pointer items-center justify-between rounded-lg border border-gray-200 bg-white pr-2.5 shadow-xs hover:shadow-md"
          >
            <div className="flex w-0 grow items-center space-x-1 ">
            <Input.TextArea
              className="bg-components-input-bg-normal w-full rounded-lg"
              bordered={false}
              autoSize
              maxLength={120}
              allowClear
              showCount
              value={data.desc || ''}
              onChange={e => handleDescriptionChange(e.target.value)}
            />
            </div>
            <div className="ml-2 flex shrink-0 items-center">
              <InputVarTypeIcon
                type={InputVarType.textInput}
                className="h-3.5 w-3.5 text-gray-500"
              />
            </div>
          </div>
        </Field>
      </div>
    </div>
  );
};

export default React.memo(Panel);
